import logo1 from "assets/png/logos/logo1.png";
import logo2 from "assets/png/logos/logo2.png";
import logo3 from "assets/png/logos/logo3.png";
import logo4 from "assets/png/logos/logo4.png";
import logo5 from "assets/png/logos/logo5.png";
import logo6 from "assets/png/logos/logo6.png";
import logo7 from "assets/png/logos/logo7.png";
import logo8 from "assets/png/logos/logo8.png";
import logo9 from "assets/png/logos/logo9.png";
import logo10 from "assets/png/logos/logo10.png";
import logo11 from "assets/png/logos/logo11.png";
import logo12 from "assets/png/logos/logo12.png";
import logo13 from "assets/png/logos/logo13.png";

const logos = [
  logo1, logo2, logo3, logo4, logo5, logo6, logo7,
  logo8, logo9, logo10, logo11, logo12, logo13,
];

const TrustedBy = () => {
  return (
    <div className="w-full bg-white px-6 sm:px-10 xl:px-20 py-14 xl:py-20 flex flex-col items-center gap-10">
      {/* Header */}
      <div data-aos="fade-up" className="flex flex-col items-center gap-3 text-center">
        <h2 className="text-[28px] sm:text-[36px] xl:text-[40px] font-black text-[#1A1A2E]">
          Trusted By{" "}
          <span className="text-[#CBA135]">50+ Leading</span>{" "}
          Organizations
        </h2>
        <p className="text-[#6B6B6B] max-w-[520px] text-sm sm:text-base leading-relaxed">
          We continue to work with organizations that rely on us for quality
          talent, dependable delivery, and long-term workforce development.
        </p>
      </div>

      {/* Logo grid — two rows, centred */}
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        className="w-full max-w-[900px] flex flex-wrap justify-center gap-4 sm:gap-6"
      >
        {logos.map((src, i) => (
          <div
            key={i}
            className="w-[72px] h-[72px] sm:w-[88px] sm:h-[88px] rounded-full bg-[#F3F3F3] flex items-center justify-center overflow-hidden p-3 sm:p-4"
          >
            <img
              src={src}
              alt={`Partner logo ${i + 1}`}
              loading="lazy"
              className="w-full h-full object-contain grayscale opacity-70"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustedBy;
